<template>
  <grid-row class="mb-4">
    <grid-column>
      <form-field-select-users
        label="Lead Manager"
        v-model="roles.lead_manager_id"
        @change="userRoleChanged"
        :selectable-users="leadManagers"
        has-empty-option
      ></form-field-select-users>

      <form-field-select-users
        label="Acquisition Manager"
        v-model="roles.acquisitions_manager_id"
        @change="userRoleChanged"
        :selectable-users="acquisitionManagers"
        has-empty-option
      ></form-field-select-users>

      <form-field-select-users
        label="Dispositions Manager"
        v-model="roles.dispositions_manager_id"
        @change="userRoleChanged"
        :selectable-users="dispositionManagers"
        has-empty-option
      ></form-field-select-users>

      <form-field-select-users
        label="Rehab Manager"
        v-model="roles.rehab_manager_id"
        @change="userRoleChanged"
        :selectable-users="rehabManagers"
        has-empty-option
      ></form-field-select-users>

      <form-field-select-users
        label="Transaction Coordinator"
        v-model="roles.transaction_coordinator_id"
        @change="userRoleChanged"
        :selectable-users="transactionCoordinators"
        has-empty-option
      ></form-field-select-users>
    </grid-column>
    <grid-column>
      <p class="mb-3">Users Assigned to this Lead</p>

      <b-field v-for="user in $store.getters.activeUsers" :key="user.id">
        <b-checkbox
          v-bind:value="userIds"
          @input="userIdsChanged"
          :native-value="user.id"
          :disabled="(!authUser.can_access_all_leads && user.id === authUser.id) || userIsSetAsRole(user)"
          size="is-small"
        >{{ user.full_name }}</b-checkbox>
      </b-field>
    </grid-column>
  </grid-row>
</template>

<script>

export default {
  name: "FormFieldSelectRecordUsers",
  props: ['userIds', 'roles'],
  data() {
    return {
      isSaving: false,
      defaultUserIds: [],
      defaultRoles: {
        lead_manager_id: null,
        acquisitions_manager_id: null,
        dispositions_manager_id: null,
        rehab_manager_id: null,
        transaction_coordinator_id: null,
      },
    }
  },
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    roleUserIds() {
      let userIds = [
        this.roles.lead_manager_id,
        this.roles.acquisitions_manager_id,
        this.roles.dispositions_manager_id,
        this.roles.rehab_manager_id,
        this.roles.transaction_coordinator_id,
      ];

      return userIds.filter(id => id !== null);
    },
    activeUsers() {
      return this.$store.getters.activeUsers;
    },
    leadManagers() {
      return this.activeUsers.filter(u => u.is_lead_manager);
    },
    acquisitionManagers() {
      return this.activeUsers.filter(u => u.is_acquisitions_manager);
    },
    dispositionManagers() {
      return this.activeUsers.filter(u => u.is_dispositions_manager);
    },
    rehabManagers() {
      return this.activeUsers.filter(u => u.is_rehab_manager);
    },
    transactionCoordinators() {
      return this.activeUsers.filter(u => u.is_transaction_coordinator);
    },
  },
  methods: {
    userIdsChanged(userIds) {
      console.log('User Ids: ', userIds);
      this.$emit('user-ids-changed', userIds);
    },
    userRoleChanged(user_id) {
      if (user_id) {
        if (this.userIds.find(userId => userId === user_id) === undefined) {
          this.$emit('user-ids-changed', [...this.userIds, user_id]);
        }
      }

      this.$emit('roles-changed', this.roles);
    },
    userIsSetAsRole(user) {
      return !!this.roleUserIds.find(u => u === user.id);
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
